import { graphql, Link } from 'gatsby'
import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import * as styles from '../styles/projectTemplate.module.css'

const ProjectTemplate = ({ data }) => {

    const project = data.markdownRemark
    const siteTitle = data.site.siteMetadata?.title || `Title`
    return (
        <Layout title={siteTitle}>
            <SEO
                title={project.frontmatter.title}
                description={project.frontmatter.description || project.excerpt}
                keywords={project.frontmatter.keyWords}
            />
            <section className={styles.html}
              dangerouslySetInnerHTML={{ __html: project.html }}
              itemProp="articleBody"
            />
            <header className={styles.btn_container}>
                <Link to={project.frontmatter.preview} target="_blank" rel="noopener noreferrer" >
                  Preview
                </Link>
                <Link to={project.frontmatter.sourceCode} target="_blank" rel="noopener noreferrer" >
                  Source Code
                </Link>
            </header>        
        </Layout>
    )
}

export default ProjectTemplate 

export const pageQuery = graphql`
  query ProjectQuery ($id: String!){
      site {
          siteMetadata {
            title
          }
        }
        markdownRemark(id: {eq: $id}){
          html
          id
        frontmatter {
          title
          description
          preview
          tools
          sourceCode
          keyWords
          image {
            childImageSharp {
              fixed(pngQuality: 10) {
                src
              }
            }
          }
        }
        id
      }
    }
`
